const DISCORD_TOUCHPOINT_NAME = 'discord';
const DISCORD_LEGACY_DISCRIMINATOR_REGEX = /#\d{4}$/;
const DISCORD_USERNAME_REGEX = /^(?!.*\.\.)[a-z0-9_.]{2,32}$/;
const DISCORD_HOSTS = [
  'discord.com',
  'www.discord.com',
  'discordapp.com',
  'www.discordapp.com',
  'discord.gg',
  'www.discord.gg',
];
const DISCORD_USERNAME_URL_HOSTS = [
  'discord.com',
  'www.discord.com',
  'discordapp.com',
  'www.discordapp.com',
];

export const isDiscordTouchpoint = (
  name: string | null | undefined
): boolean => name?.toLowerCase() === DISCORD_TOUCHPOINT_NAME;

export const isDiscordUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    return (
      ['http:', 'https:'].includes(url.protocol) &&
      DISCORD_HOSTS.includes(url.hostname.toLowerCase())
    );
  } catch {
    return false;
  }
};

const extractDiscordUsernameFromUrl = (value: string): string => {
  try {
    const url = new URL(value);
    const pathParts = url.pathname.split('/').filter(Boolean);

    if (
      DISCORD_USERNAME_URL_HOSTS.includes(url.hostname.toLowerCase()) &&
      pathParts.length === 1 &&
      pathParts[0] !== 'app'
    ) {
      return pathParts[0];
    }
  } catch {
    return value;
  }

  return value;
};

export const normalizeDiscordTouchpointValue = (
  value: string | null | undefined
): string => {
  const trimmed = (value || '').trim();

  if (!trimmed) {
    return '';
  }

  if (isDiscordUrl(trimmed)) {
    const extractedUsername = extractDiscordUsernameFromUrl(trimmed);
    return extractedUsername === trimmed
      ? trimmed
      : normalizeDiscordTouchpointValue(extractedUsername);
  }

  return trimmed
    .replace(/^@+/, '')
    .replace(DISCORD_LEGACY_DISCRIMINATOR_REGEX, '')
    .toLowerCase();
};

export const isValidDiscordTouchpointValue = (
  value: string | null | undefined
): boolean => {
  const normalized = normalizeDiscordTouchpointValue(value);

  if (!normalized) {
    return true;
  }

  if (isDiscordUrl(normalized)) {
    return true;
  }

  return DISCORD_USERNAME_REGEX.test(normalized);
};

export const copyOrOpenDiscordTouchpoint = async (
  value: string | null | undefined
): Promise<boolean> => {
  const normalized = normalizeDiscordTouchpointValue(value);

  if (!normalized || typeof window === 'undefined') {
    return false;
  }

  if (isDiscordUrl(normalized)) {
    window.open(normalized, '_blank');
    return false;
  }

  try {
    await window.navigator.clipboard.writeText(normalized);
    return true;
  } catch {
    return false;
  }
};
